var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('ToolBar'),_vm._v(" "),_c('v-content',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('AlertBar'),_vm._v(" "),_c('router-view')],1)],1),_vm._v(" "),_c('NotificationBar'),_vm._v(" "),_c('LogSheet'),_vm._v(" "),_c('ProcessDetails')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-216c8932","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 